// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"9ab7aa9f","238":"eb5f4e69","605":"87964ada","905":"1b0f21ce"}[chunkId] + ".chunk.js";
};